import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15bf1b31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Assessment", -1))
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left-circle" }, null, -1))
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-subscription-table-toolbar": "base"
}
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = {
  key: 0,
  class: "overlay-layer text-center rounded"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["id"]
const _hoisted_12 = ["id"]
const _hoisted_13 = ["id"]
const _hoisted_14 = ["data-bs-target", "aria-controls"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["title"]
const _hoisted_17 = ["id", "aria-labelledby", "data-bs-parent"]
const _hoisted_18 = { class: "accordion-body" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "row mb-2"
}
const _hoisted_21 = { class: "col-lg-6 mb-2 fv-row" }
const _hoisted_22 = { class: "d-flex flex-column w-100 me-2" }
const _hoisted_23 = { class: "d-flex flex-stack mb-2" }
const _hoisted_24 = { class: "text-muted me-2 fs-7 fw-bold" }
const _hoisted_25 = { class: "progress h-6px w-100" }
const _hoisted_26 = { class: "progress h-6px w-100" }
const _hoisted_27 = ["aria-valuenow"]
const _hoisted_28 = { class: "col-lg-6 mb-2 fv-row" }
const _hoisted_29 = { class: "d-flex flex-column w-100 me-2" }
const _hoisted_30 = { class: "d-flex flex-stack mb-2" }
const _hoisted_31 = { class: "text-muted me-2 fs-7 fw-bold" }
const _hoisted_32 = { class: "progress h-6px w-100" }
const _hoisted_33 = { class: "progress h-6px w-100" }
const _hoisted_34 = ["aria-valuenow"]
const _hoisted_35 = {
  class: "row mb-2",
  "data-kt-buttons": "true"
}
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "fs-6 text-decoration-underline fw-bold" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = { class: "form-check form-check-custom form-check-solid me-10" }
const _hoisted_41 = ["disabled", "onChange", "checked", "name"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Yes ", -1))
const _hoisted_43 = { class: "form-check form-check-custom form-check-solid me-10" }
const _hoisted_44 = ["disabled", "onChange", "name", "checked"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " No ", -1))
const _hoisted_46 = { class: "form-check form-check-custom form-check-solid me-10" }
const _hoisted_47 = ["disabled", "onChange", "name", "checked"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Don't Know ", -1))
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "d-flex align-items-center" }
const _hoisted_51 = { class: "form-check form-check-custom form-check-solid me-10" }
const _hoisted_52 = ["disabled", "onChange", "name", "checked"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Yes ", -1))
const _hoisted_54 = { class: "form-check form-check-custom form-check-solid me-10" }
const _hoisted_55 = ["disabled", "onChange", "name", "checked"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " No ", -1))
const _hoisted_57 = { key: 2 }
const _hoisted_58 = { class: "d-flex align-items-center" }
const _hoisted_59 = { key: 3 }
const _hoisted_60 = { class: "d-flex align-items-center" }
const _hoisted_61 = { key: 4 }
const _hoisted_62 = { key: 5 }
const _hoisted_63 = ["disabled", "onChange"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "null" }, "Select", -1))
const _hoisted_65 = ["selected", "label", "value"]
const _hoisted_66 = ["id", "onClick"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit section for scoring ", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RadialChart = _resolveComponent("RadialChart")!
  const _component_TextareaComponent = _resolveComponent("TextareaComponent")!
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_RatingComponent = _resolveComponent("RatingComponent")!
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/home",
          class: "btn mx-2 btn-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.submitted)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary me-3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.locked = !_ctx.locked))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass([_ctx.locked === true ? 'bi-lock-fill' : 'bi-unlock-fill', "bi"])
                }, null, 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.data)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (items, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "accordion",
          id: `kt_accordion_${i}`,
          key: i
        }, [
          _createElementVNode("div", {
            class: "accordion-item",
            id: `pdf${items.description}`
          }, [
            _createElementVNode("h2", {
              class: "accordion-header",
              id: `kt_accordion_1_header_${i}`
            }, [
              _createElementVNode("button", {
                class: "questions accordion-button fs-4 fw-bold collapsed",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#kt_accordion_1_body_${i}`,
                "aria-expanded": "true",
                "aria-controls": `kt_accordion_1_body_${i}`
              }, [
                _createTextVNode(_toDisplayString(items.description) + " ", 1),
                (
                  _ctx.percentData[i].count_answers > 0 ||
                  _ctx.percentData[i].section_submitted === 1
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createElementVNode("i", {
                        class: _normalizeClass([
                    _ctx.percentData[i]?.section_submitted === 0
                      ? ' bi-hourglass-top text-warning '
                      : _ctx.percentData[i].count_answers ===
                          _ctx.percentData[i].count_questions &&
                        _ctx.percentData[i].section_submitted === 1
                      ? 'bi-check-circle-fill text-success'
                      : 'bi-hourglass-split text-primary'
                  , "bi p-1 fs-6"]),
                        "data-bs-toggle": "tooltip",
                        title: 
                    _ctx.percentData[i]?.section_submitted === 0
                      ? 'Survey in process'
                      : _ctx.percentData[i].count_answers ===
                          _ctx.percentData[i].count_questions &&
                        _ctx.percentData[i].section_submitted === 1
                      ? 'Done'
                      : 'Scoring in process'
                  
                      }, null, 10, _hoisted_16)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_14)
            ], 8, _hoisted_13),
            _createElementVNode("div", {
              id: `kt_accordion_1_body_${i}`,
              class: _normalizeClass(`accordion-collapse collapse  ${i === 0 ? 'show' : ''}`),
              "aria-labelledby": `kt_accordion_1_header_${i}`,
              "data-bs-parent": `#kt_accordion_${i}`
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: "btn btn-primary me-3",
                  onClick: ($event: any) => (_ctx.createPdf(i))
                }, " Download ", 8, _hoisted_19),
                (_ctx.percentData[i].section_submitted === 0)
                  ? (_openBlock(), _createBlock(_component_RadialChart, {
                      key: 0,
                      info: `${_ctx.percentData[i]?.count_answers}/${_ctx.percentData[i]?.count_questions}`,
                      description: _ctx.percentData[i]?.description,
                      percent: 
                  _ctx.getPercent(
                    _ctx.percentData[i]?.count_answers,
                    _ctx.percentData[i]?.count_questions
                  )
                
                    }, null, 8, ["info", "description", "percent"]))
                  : _createCommentVNode("", true),
                (_ctx.percentData[i].section_submitted === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.percentData[i]?.score_value) + "% ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["progress-bar", _ctx.getColor(_ctx.percentData[i]?.score_value)]),
                                role: "progressbar",
                                style: _normalizeStyle({
                            width: _ctx.percentData[i]?.score_value + '%',
                          }),
                                "aria-valuenow": _ctx.percentData[i]?.score_value,
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }, null, 14, _hoisted_27)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.percentData[i]?.average_value) + "% ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", {
                                class: "progress-bar bg-success",
                                role: "progressbar",
                                style: _normalizeStyle({
                            width: _ctx.percentData[i]?.average_value + '%',
                          }),
                                "aria-valuenow": _ctx.percentData[i]?.average_value,
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }, null, 12, _hoisted_34)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  ref_for: true,
                  ref: 
                  (el) => {
                    _ctx.PdfExportRef[i] = el;
                  }
                
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.questions, (question, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass([
                      _ctx.locked === true && _ctx.percentData[i]?.section_submitted === 1
                        ? 'disabled'
                        : ''
                    , "mb-10 fv-row"])
                    }, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("p", _hoisted_37, _toDisplayString(question?.description), 1),
                          (question.type?.type === 'Yes/No/Don\'t Know')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("label", _hoisted_40, [
                                    _createElementVNode("input", {
                                      disabled: 
                                  _ctx.locked === true &&
                                  items.section_submitted === 1
                                ,
                                      onChange: ($event: any) => (
                                  _ctx.setValue(items.id, question.id, 5, null)
                                ),
                                      class: "form-check-input h-20px w-20px",
                                      type: "radio",
                                      checked: question?.answer?.value === 5,
                                      name: `data[${i}][${index}]`,
                                      value: "5"
                                    }, null, 40, _hoisted_41),
                                    _hoisted_42
                                  ]),
                                  _createElementVNode("label", _hoisted_43, [
                                    _createElementVNode("input", {
                                      disabled: 
                                  _ctx.locked === true &&
                                  items.section_submitted === 1
                                ,
                                      onChange: ($event: any) => (
                                  _ctx.setValue(items.id, question.id, 1, null)
                                ),
                                      class: "form-check-input h-20px w-20px",
                                      type: "radio",
                                      name: `data[${i}][${index}]`,
                                      checked: question?.answer?.value === 1,
                                      value: "1"
                                    }, null, 40, _hoisted_44),
                                    _hoisted_45
                                  ]),
                                  _createElementVNode("label", _hoisted_46, [
                                    _createElementVNode("input", {
                                      disabled: 
                                  _ctx.locked === true &&
                                  items.section_submitted === 1
                                ,
                                      onChange: ($event: any) => (
                                  _ctx.setValue(items.id, question.id, -1, null)
                                ),
                                      class: "form-check-input h-20px w-20px",
                                      type: "radio",
                                      name: `data[${i}][${index}]`,
                                      checked: question?.answer?.value === -1,
                                      value: "-1"
                                    }, null, 40, _hoisted_47),
                                    _hoisted_48
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (question.type?.type === 'Yes/No')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("label", _hoisted_51, [
                                    _createElementVNode("input", {
                                      disabled: 
                                  _ctx.locked === true &&
                                  items.section_submitted === 1
                                ,
                                      onChange: ($event: any) => (
                                  _ctx.setValue(items.id, question.id, 5, null)
                                ),
                                      class: "form-check-input h-20px w-20px",
                                      type: "radio",
                                      name: `data[${i}][${index}]`,
                                      checked: question?.answer?.value === 5,
                                      value: "5"
                                    }, null, 40, _hoisted_52),
                                    _hoisted_53
                                  ]),
                                  _createElementVNode("label", _hoisted_54, [
                                    _createElementVNode("input", {
                                      disabled: 
                                  _ctx.locked === true &&
                                  items.section_submitted === 1
                                ,
                                      onChange: ($event: any) => (
                                  _ctx.setValue(items.id, question.id, 1, null)
                                ),
                                      class: "form-check-input h-20px w-20px",
                                      type: "radio",
                                      name: `data[${i}][${index}]`,
                                      checked: question?.answer?.value === 1,
                                      value: "1"
                                    }, null, 40, _hoisted_55),
                                    _hoisted_56
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (question.type?.type === 'Info/Text')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                  _createVNode(_component_TextareaComponent, {
                                    onRatingValue: _ctx.setRating,
                                    items: {item:items.id, question:question.id},
                                    "data-index": i,
                                    "question-index": index,
                                    value: question?.answer?.text
                                  }, null, 8, ["onRatingValue", "items", "data-index", "question-index", "value"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (question.type?.type === 'Field')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                _createElementVNode("div", _hoisted_60, [
                                  _createVNode(_component_InputComponent, {
                                    onRatingValue: _ctx.setRating,
                                    items: {item:items.id, question:question.id},
                                    "data-index": i,
                                    "question-index": index,
                                    value: question?.answer?.text
                                  }, null, 8, ["onRatingValue", "items", "data-index", "question-index", "value"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (question.type?.type === 'Rating')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _createVNode(_component_RatingComponent, {
                                  onRatingValue: _ctx.setRating,
                                  items: {item:items.id, question:question.id},
                                  "data-index": i,
                                  "question-index": index,
                                  value: question?.answer?.value
                                }, null, 8, ["onRatingValue", "items", "data-index", "question-index", "value"])
                              ]))
                            : _createCommentVNode("", true),
                          (question.type?.status == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _createElementVNode("select", {
                                  disabled: 
                              _ctx.locked === true && items.section_submitted === 1
                            ,
                                  onChange: ($event: any) => (
                              _ctx.setValue(
                                items.id,
                                question.id,
                                null,
                                $event.target.value
                              )
                            ),
                                  class: "form-select form-select-solid select2-hidden-accessible"
                                }, [
                                  _hoisted_64,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.list?.info, (list, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      selected: 
                                question?.answer?.text === list.description
                              ,
                                      label: list.description,
                                      value: list?.description,
                                      key: index
                                    }, _toDisplayString(list.description), 9, _hoisted_65))
                                  }), 128))
                                ], 40, _hoisted_63)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2))
                  }), 128))
                ], 512),
                _createElementVNode("button", {
                  class: "btn btn-flex btn-primary",
                  id: `section-submit-${items.id}`,
                  onClick: ($event: any) => (_ctx.submitting(items.id))
                }, _hoisted_69, 8, _hoisted_66)
              ])
            ], 10, _hoisted_17)
          ], 8, _hoisted_12)
        ], 8, _hoisted_11))
      }), 128)),
      _createVNode(_component_notifications, {
        group: "foo-css",
        position: "bottom left",
        speed: 500
      })
    ])
  ]))
}